
export const download = (response, filename = null, mimetype = 'octet/stream') => {
    const extractFilename = /filename=([\w.\-_]*)/;
    if (!response.data || response.status === 204) {
        throw new Error('No content');
    }
    try {
        const data = response.data;
        if (!filename) {
            filename = extractFilename.exec(response.headers['content-disposition'])[1];
        }
        const blob = new Blob([data], { type: mimetype });
        const link = document.createElement('a');
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        link.download = filename;
        document.body.append(link);
        link.click();
        link.remove();
        window.addEventListener('focus', () => URL.revokeObjectURL(link.href), { once: true });
    } catch (err) {
        console.warn(err);
    }
};
